import angular from 'angular';
import lenderSelection from './lenderSelection';

export default angular
  .module('components.lenderSelection', [])
  .component('lenderSelection', lenderSelection).name;
